import CollectionList     from "@/js/Shared/Collections/CollectionList";
import MessagesCollection from "./MessagesCollection";

export {ViewportCollection as default};

/**
* Viewport Collection
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class ViewportCollection extends CollectionList {
  /**
   * Returns a message list collection by folder id
   *
   * Returns an empty collection if folders does not exist
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {String} folder_id
   *
   * @return {MessagesCollection}
   */
  get(folder_id) {
    return this.index[folder_id] || new MessagesCollection();
  }
}